/**
 * File custom.js.
 */

(function ($) {
	'use strict';

    jQuery(document).ready(function($) {
        var maxLength = 2000;
    
        $(".wp-block-contact-form__wrap textarea.form-control").each(function() {
            var $this = $(this);
            var id = $this.attr("id");
    
            $this.on("input", function() {
                var currentLength = $this.val().length;
    
                // Enforce limit (prevents typing beyond maxLength)
                if (currentLength > maxLength) {
                    $this.val($this.val().substring(0, maxLength));
                    currentLength = maxLength;
                }
    
                var charsLeft = maxLength - currentLength;
                $("#" + id + "_remaining").text(charsLeft);
    
                var percent = (currentLength / maxLength) * 100;
                var $progress = $("#" + id + "_progress");
    
                $progress.css("width", percent + "%");
            });
        });
    });

})(jQuery);
